const taskTemplates = require('data/task-templates');

const tasksData = [
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-duration',
		difficulty: 'easy',
    text: `Hvor mange år tager en HHX?`,
    shuffleOptions: false,
    image: 'hhx-1',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: '1', 
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: '2'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: '3', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: '4'
      })
    ],
  }),
  Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 'sort-required-subjects',
		difficulty: 'hard',
		text: `Hvilke fag kan du få på HHX?`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'available', 
				title: `HHX-fag:`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'notAvailable', 
				title: `Disse fag har man ikke:`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Virksomhedsøkonomi`, categoryIds: ['available']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Afsætning`, categoryIds: ['available']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Jura`, categoryIds: ['available']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `International økonomi`, categoryIds: ['available']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Kemi`, categoryIds: ['notAvailable']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Oldtidskundskab`, categoryIds: ['notAvailable']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Fysik`, categoryIds: ['notAvailable']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, text: `Latin`, categoryIds: ['notAvailable']
			})
		]
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-basic-when',
		difficulty: 'medium',
    text: `Hvor længe varer grundforløbet på HHX?`,
    image: 'hhx-2',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: '6 måneder', 
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: '3 måneder', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: '9 måneder'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: '12 månder'
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-basic-why',
		difficulty: 'easy',
    text: `Hvad er formålet med grundforløbet på HHX?`,
    image: 'hhx-22',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'At gøre eleverne klar til de første eksamener i 1.g', 
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'At eleverne kan blive afklaret omkring hvilken studieretning de ønsker', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'At blive introduceret til skolens regler og traditioner'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'At vælge valgfag til hele gymnasietiden'
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-a-levels',
		difficulty: 'easy',
    text: `På HHX skal mindst tre fag være på A-niveau, men er der mulighed for at vælge flere A-fag?`,
    image: 'hhx-3',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Ja, nogle studieretninger og valgfag kan give flere A-fag', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Nej, alle elever har altid præcis tre A-fag'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'Ja, men kun hvis skolen selv beslutter det'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'Nej, ekstra A-fag findes kun på STX'
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-hhx-acronym',
		difficulty: 'medium',
    text: `Hvad står bogstaverne HHX for?`,
    image: 'hhx-23',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Højere Handelseksamen', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Højere Handelsuddannelse'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'Handelsfaglig Hovedeksamen'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'Højere Humanistisk Eksamen'
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-choose-direction-when',
		difficulty: 'medium',
    text: `Hvornår skal eleverne senest vælge studieretning på HHX?`,
    image: 'hhx-4',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Efter de første tre måneder i grundforløbet', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Før sommerferien i 9. klasse'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'Ved skolestart i august'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'Inden 2.g'
      })
    ],
  }),
  // Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
	// 	taskId: 'sort-subjects-paths',
	// 	difficulty: 'medium',
	// 	text: `Hvilke udsagn passer til studieretningerne på HHX?`,
  //   layout: 'halfdouble-height',
	// 	categories: [
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'fits', 
	// 			title: `Passer til studieretningerne`
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'noFit', 
	// 			title: `Passer ikke til studieretningerne`
	// 		}),
	// 	],
	// 	items: [
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 1, text: `Består af en kombination af fag`, categoryIds: ['fits']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 2, text: `Afgør hvilke fag der løftes til A-niveau`, categoryIds: ['fits']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 3, text: `Har betydning for adgang til videregående uddannelser`, categoryIds: ['fits']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 4, text: `Giver altid de samme adgangsmuligheder`, categoryIds: ['noFit']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 5, text: `Fag på studieretningerne skal være A-niveau fag`, categoryIds: ['noFit']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 6, text: `Vælges i 2.g`, categoryIds: ['noFit']
	// 		})
	// 	]
	// }),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		taskId: 'order-levels',
		difficulty: 'easy',
		text: `På HHX findes fag på forskellige niveauer. Sorter niveauerne fra det højeste til det laveste.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `A-niveau`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `B-niveau`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `C-niveau`, correctOrderNumbers: [3]
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		taskId: 'order-events',
		difficulty: 'medium',
		text: `Sæt de vigtigste begivenheder på HHX i rigtig rækkefølge fra første til sidste.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Første skoledag`, correctOrderNumbers: [1]
			}),
			// Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
			// 	id: 2, text: `Afslutning af grundforløbet`, correctOrderNumbers: [2]
			// }),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Valg af studieretning`, correctOrderNumbers: [2]
			}),
      Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Første eksamen`, correctOrderNumbers: [3]
			}),
      Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Sidste skoledag`, correctOrderNumbers: [4]
			}),
      // Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
			// 	id: 5, text: `Sidste eksamen`, correctOrderNumbers: [5]
			// }),
      Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Modtagelse af hue og eksamensbevis`, correctOrderNumbers: [5]
			}),
		]
	}),
  // Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
  //   taskId: 'mc-number-of-fields',
	// 	difficulty: 'hard',
  //   text: `Hvor mange studieretninger findes der på HHX?`,
  //   shuffleOptions: false,
  //   image: 'hhx-24',
  //   options: [
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 1, text: '10',
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 2, text: '11'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 3, text: '12'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 4, text: '13', isCorrect: true
  //     })
  //   ],
  // }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-all-schools-have-all-fields',
		difficulty: 'medium',
    text: `Tilbyder alle HHX gymnasier alle studieretninger?`,
    image: 'hhx-5',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Ja, alle gymnasier tilbyder de samme HHX studieretninger'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Nej, hvert gymnasium udbyder et udvalg af studieretninger', isCorrect: true
      })
    ],
  }),
  // Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
  //   taskId: 'mc-fields-true',
	// 	difficulty: 'medium',
  //   text: `Hvilke to udsagn tror I er rigtigt om studieretninger på HHX?`,
  //   showNumberOfAnswersToSelect: false,
  //   image: 'hhx-6',
  //   options: [
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 1, text: 'Du kan vælge studieretning hvert år'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 2, text: 'Valget af studieretning påvirker hvilke fag og niveauer du får', isCorrect: true
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 3, text: 'Valg af studieretning kan have betydning for videregående uddannelser', isCorrect: true
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 4, text: 'Alle studieretninger giver adgang til alle uddannelser'
  //     })
  //   ],
  // }),
  Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 'sort-required-optional',
		difficulty: 'hard',
		text: `På HHX er nogle fag obligatoriske, mens andre kan vælges som valgfag. Her ses en blanding af begge typer – sorter dem i de rigtige kategorier.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'required', 
				title: `Obligatoriske fag:`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'notRequired', 
				title: `Ikke obligatoriske fag:`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Engelsk`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Afsætning`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Virksomhedsøkonomi`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Tysk`, categoryIds: ['notRequired']
			}),
      Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Psykologi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Innovation`, categoryIds: ['notRequired']
			})
		]
	}),
  // Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
	// 	taskId: 'sort-levels-subjects',
	// 	difficulty: 'hard',
	// 	text: `På HHX er fagene på tre niveauer: A, B og C – og A er det højeste. Hvilket niveau har man som udgangspunkt de her fag på?`,
	// 	categories: [
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'a-level', 
	// 			title: `A-niveau`
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'b-level', 
	// 			title: `B-niveau`
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'c-level', 
	// 			title: `C-niveau`
	// 		}),
	// 	],
	// 	items: [
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 1, text: `Dansk`, categoryIds: ['a-level']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 2, text: `Engelsk`, categoryIds: ['a-level']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 3, text: `Afsætning`, categoryIds: ['b-level']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 4, text: `Matematik`, categoryIds: ['b-level']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 5, text: `Erhvervsjura`, categoryIds: ['c-level']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 6, text: `Samfundsfag`, categoryIds: ['c-level']
	// 		})
	// 	]
	// }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-a-level-statements',
		difficulty: 'medium',
    text: `Hvilke to udsagn om A-niveaufag på HHX er rigtige?`,
    showNumberOfAnswersToSelect: false,
    image: 'hhx-7',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Som elev på HHX skal du have mindst 3 fag på A-niveau', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Som elev på HHX skal du have mindst 4 fag på A-niveau'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'Man kan godt vælge at få endnu flere A-niveau fag hvis man selv ønsker det', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'Man kan ikke vælge at få flere A-niveau fag hvis man selv ønsker det'
      }),
      // Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
      //   id: 5, text: 'Man kan vælge de samme valgfag på alle HHX gymnasier i Danmark'
      // }),
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-fields-images',
		difficulty: 'easy',
    text: `Find de 3 billeder, der passer til HHX-studieretninger.`,
    subtype: 'images',
	 	layout: 'fields-of-study',
    showNumberOfAnswersToSelect: false,
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 'science'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 'society', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 'languages', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 'art', 
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 'finance', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 'media'
      }),
    ],
  }),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 'sort-subjects-emojis',
		difficulty: 'easy',
		subtype: 'images',
		text: `Her er nogle emojis, der viser fagene og temaerne på HHX. Hvilket fag eller tema passer de til?`,
		layout: 'subjects-emojis',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'finance', title: `Finans`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'sales', title: `Afsætning`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'languages', title: `Sprog`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'business-law', title: `Erhvervsjura`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'money', type: 'image', categoryIds: ['finance']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'bank', type: 'image', categoryIds: ['finance']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'megaphone', type: 'image', categoryIds: ['sales']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'cart', type: 'image', categoryIds: ['sales']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'earth', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'flag', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'scales', type: 'image', categoryIds: ['business-law']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'court', type: 'image', categoryIds: ['business-law']})
		]
	}),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	taskId: 'order-steps-fields',
	// 	difficulty: 'medium',
	// 	text: `Sæt trinnene for valg af studieretning på HHX i den rækkefølge, de typisk sker.`,
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 1, text: `Intro-arrangement og grundforløb`, correctOrderNumbers: [1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 2, text: `Undersøg studieretninger og fag`, correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 3, text: `Tal med vejleder`, correctOrderNumbers: [3]
	// 		}),
  //     Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 4, text: `Overvej interesser og fremtid`, correctOrderNumbers: [4]
	// 		}),
  //     Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 5, text: `Vælg og søg en studieretning`, correctOrderNumbers: [5]
	// 		}),
  //     Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 6, text: `Start på fagene`, correctOrderNumbers: [6]
	// 		}),
	// 	]
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		subtype: 'images',
		difficulty: 'easy',
		taskId: 'mc-school-items',
		text: `Hvilket udstyr er typisk nødvendigt for en dag på HHX med fag og projekter?`,
		layout: 'hhx-school-items',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'laptop', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'books'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'group-work', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'phone'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'money',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'smartboard', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'chefs-hat',
			}),
		],
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-new-students',
		difficulty: 'hard',
    text: `Ca. hvor mange elever starter på HHX hvert år i Danmark?`,
    image: 'hhx-8',
    shuffleOptions: false,
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Ca. 5.000'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Ca. 7.500'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'Ca. 10.000'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'Ca. 12.500', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 5, text: 'Ca. 15.000'
      }),
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-typical-student',
		difficulty: 'easy',
    text: `Hvilke tre ting beskriver typisk elever, der vælger HHX?`,
    showNumberOfAnswersToSelect: false,
    image: 'hhx-9',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'De vil gerne lære om sprog, økonomi, erhvervsliv og samfund', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'De foretrækker praktisk arbejde i laboratorier og værksteder'
      }),
      // Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
      //   id: 3, text: 'De kan lide undervisning, der er mere teoretisk end praktisk', isCorrect: true
      // }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'De trives bedst med korte lektioner og få hjemmearbejdsopgaver'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 5, text: 'De trives med at bruge tid på forberedelse, lektier og opgaver', isCorrect: true
      }),
    ],
  }),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 'sort-basic-statements',
		difficulty: 'medium',
		text: `Grundforløb på HHX – sorter udsagnene i kategorierne “Sandt om grundforløbet” og “Falsk om grundforløbet”.`,
		layout: 'halfdouble-height',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'true', title: `Sandt om grundforløbet:`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'false', title: `Falsk om grundforløbet:`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Introduktion til fag og studieretninger`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `De første 3 måneder på HHX er grundforløb`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Alle har de samme fag på grundforløbet`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Introduktion til alle gymnasiets undervisere og vejledere`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Grundforløbet starter efter de første 3 måneder`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Man vælger selv, hvilke fag man skal have på grundforløbet`, categoryIds: ['false']}),
		]
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-what-to-do',
		difficulty: 'easy',
    text: `Hvad er det bedste at gøre, hvis HHX virker spændende?`,
    image: 'hhx-25',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Vente til efter studentereksamen med at beslutte sig'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Tage til åbent hus og høre mere om uddannelsen', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3, text: 'Læse mere på unord.dk', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4, text: 'Tale med en vejleder om mulighederne', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 5, text: 'Undlade at undersøge noget, fordi det er for tidskrævende'
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 6, text: 'Beslutte sig i god tid og ansøge', isCorrect: true
      }),
    ],
  }),  
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		taskId: 'order-steps-uni',
		difficulty: 'easy',
		text: `Hvad er rækkefølgen for en HHX gymnasieelev, der drømmer om et job med en universitetsuddannelse? Sæt trinnene i rigtig rækkefølge – fra start til slut.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Færdiggøre grundskolen`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Begynde på gymnasiet`, correctOrderNumbers: [2]
			}),
			// Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
			// 	id: 3, text: `Vælge studieretning og fagpakke`, correctOrderNumbers: [3]
			// }),
      Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Få sin studentereksamen`, correctOrderNumbers: [3]
			}),
      Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Fuldføre videregående uddannelse`, correctOrderNumbers: [4]
			}),
      Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Starte i job`, correctOrderNumbers: [5]
			}),
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 'sort-dreams',
		difficulty: 'medium',
		text: `Hvilke jobs og karrierer drømmer mange HHX-elever typisk om?`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'typical', title: `Typiske drømme`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notTypical', title: `Ikke typiske drømme`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Økonom`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Revisor`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Salgsdirektør`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Iværksætter`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Marketingchef`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 9, text: `Læge`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 10, text: `Programmør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 11, text: `Frisør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 12, text: `Ingeniør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 13, text: `Pædagog`, categoryIds: ['notTypical']})
		]
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-future-limits',
		difficulty: 'easy',
    text: `Hvis man vælger HHX, sætter det så grænser for, hvad man kan blive i fremtiden?`,
    image: 'hhx-10',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Nej', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Ja'
      }),
    ],
  }),
	// Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
	// 	taskId: 'sort-intros',
	// 	difficulty: 'medium',
	// 	text: `Når man starter på HHX gymnasiet, er der en introduktion. Placer elementerne i de kategorier, de hører til.`,
	// 	categories: [
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'social', title: `Det sociale`}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'school', title: `Det skolerelaterede`}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notIntro', title: `Ikke en del af intro`}),
	// 	],
	// 	items: [
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Møde de nuværende elever`, categoryIds: ['social']}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Teambuilding`, categoryIds: ['social']}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Gruppearbejde i klassen`, categoryIds: ['school']}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Info om fag`, categoryIds: ['school']}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Udlevering af bøger`, categoryIds: ['school']}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Introduktion til eksamener`, categoryIds: ['notIntro']}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Gennemgang af skolens sikkerhedsregler`, categoryIds: ['notIntro'], layout: 'item-halfdouble'}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Oplæring i skolens IT`, categoryIds: ['notIntro']}),
	// 	]
	// }),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		taskId: 'order-traditions',
		difficulty: 'easy',
		text: `Gymnasiet har mange traditioner og fester. Sæt begivenhederne i den rækkefølge, de normalt sker – fra starten af gymnasiet til slutningen.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Introfest`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Studieture`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Gallafest`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Dimissionsfest`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Studenterkørsel`, correctOrderNumbers: [5]
			})
			// Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
			// 	id: 6, text: `Reunion fest`, correctOrderNumbers: [6]
			// })
		]
	}),
  // Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
  //   taskId: 'mc-student-trips',
	// 	difficulty: 'hard',
  //   text: `Hvor mange studieture har man som udgangspunkt på HHX?`,
  //   shuffleOptions: false,
  //   image: 'hhx-11',
  //   options: [
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 1, text: '1', isCorrect: true
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 2, text: '2'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 3, text: '3'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 4, text: '4'
  //     })
  //   ],
  // }),
  // Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
  //   taskId: 'mc-student-trip-when',
	// 	difficulty: 'medium',
  //   text: `Hvornår på HHX plejer studieturen at være?`,
  //   shuffleOptions: false,
  //   image: 'hhx-12',
  //   options: [
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 1, text: '1.g'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 2, text: '2.g', isCorrect: true
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 3, text: '3.g'
  //     })
  //   ],
  // }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    taskId: 'mc-student-trips-depend-field',
		difficulty: 'hard',
    text: `Kan antallet af studieture på HHX være forskelligt alt efter studieretning?`,
    image: 'hhx-13',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1, text: 'Ja', isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2, text: 'Nej'
      }),
    ],
  }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-study-trip-experiences',
		difficulty: 'easy',
		text: `Hvad oplever og laver man typisk på en studietur på HHX?`,
    image: 'hhx-14',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Tager på udflugter', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Tager ud og spiser', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 3, text: 'Tager på Seightseeing', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Laver lektier'
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 5, text: 'Fester om aftenen'
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Sidder alene på værelset hele dagen'
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 'sort-myths',
		difficulty: 'medium',
		text: `Sortér udsagnene i to kategorier: Myter og fakta om studielivet på HHX.`,
		layout: 'halfdouble-height',
		categories: [
      Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'myth', title: `Myter`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'fact', title: `Fakta`}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Gymnasiet arrangerer fester for eleverne`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Man kommer ikke uden om gruppearbejde`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Elevrådet arbejder for elevernes interesser`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Man skal være vildt god til matematik for at klare HHX`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Der er mange som ikke gennemfører`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `HHX er ikke en rigtig studentereksamen`, categoryIds: ['myth']})
		]
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-teaching-statements',
		difficulty: 'medium',
		text: `Hvad er sandt om undervisningen på HHX?`,
    image: 'hhx-15',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Du får både klasseundervisning, gruppearbejde og projektarbejde', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Forberedelse og lektier fylder en del af hverdagen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Man afleverer kun én skriftlig opgave pr. år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Alle eksamener ligger kun i 3.g'
			})
		],
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-subjects-not-at-hhx',
		difficulty: 'easy',
		text: `Hvilke tre fag har man ikke på HHX sammenlignet med de andre gymnasier?`,
    showNumberOfAnswersToSelect: false,
    image: 'hhx-26',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Oldtidskundskab', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Biologi', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Fysik', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Matematik'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Dansk'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Engelsk'
			}),      
		],
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-subjects-only-at-hhx',
		difficulty: 'easy',
		text: `Hvilke tre fag findes kun på HHX?`,
    showNumberOfAnswersToSelect: false,
    image: 'hhx-27',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Afsætning', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'International økonomi', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Erhvervsjura', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Teknologi'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Matematik'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Kemi'
			}),      
		],
	}),
  // Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	subtype: 'images',
	// 	difficulty: 'hard',
	// 	taskId: 'mc-classroom-hours',
	// 	text: `Hvor mange timer har man typisk undervisning om ugen på HHX?`,
	// 	layout: 'hhx-classroom-hours',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3, isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4
	// 		})
	// 	],
	// }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-wellbeing',
		difficulty: 'medium',
		text: `Hvad gør gymnasier typisk for at styrke trivslen blandt eleverne på HHX?`,
    image: 'hhx-16',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Tilbyder studievejledning og samtaler med elever', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Arrangerer sociale aktiviteter og introforløb', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Giver fri når solen skinner'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Tilbyder lektiecaféer og faglig støtte', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Har faste regler for, hvor mange afleveringer der må ligge samme uge'
			})
		],
	}),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-teaching-types',
		difficulty: 'medium',
		text: `Hvordan foregår undervisningen typisk på HHX?`,
    image: 'hhx-17',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Teori'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Praksis'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'En blanding', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-new-things',
		difficulty: 'medium',
		text: `Når nye elever starter på HHX, er der mange nye ting at vænne sig til. Hvad opleves typisk som det sværeste i starten?`,
    image: 'hhx-18',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Mange afleveringer', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Det højere tempo i undervisningen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'At tale foran hele klassen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'At finde vej til klasselokalerne'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'At vænne sig til kantinemaden'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'At bruge nye digitale platforme'
			})
		],
	}),
  // Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
  //   taskId: 'mc-exam-forms',
	// 	difficulty: 'hard',
  //   text: `Hvor mange eksamensformer findes der på HHX?`,
  //   image: 'hhx-19',
  //   shuffleOptions: false,
  //   options: [
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 1, text: '1', 
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 2, text: '2', isCorrect: true
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 3, text: '3'
  //     }),
  //     Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
  //       id: 4, text: '4'
  //     })
  //   ],
  // }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-who-choose-hhx',
		difficulty: 'easy',
		text: `For hvem er HHX den oplagte gymnasievej?`,
    image: 'hhx-20',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Elever med interesse for erhvervsliv, økonomi og handel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Elever der vil fordybe sig i naturvidenskab og laboratoriefag'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Elever der brænder for kunst, musik og teater'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Elever der drømmer om at arbejde inden for sundhed og medicin'
			})
		],
	}),
   Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 'mc-hat-color',
		difficulty: 'hard',
		text: `Hvilken farve har studenterhuen for HHX?`,
    image: 'hhx-21',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Bordeaux'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Kongeblå', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Lyseblå'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Marineblå'
			})
		],
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
  /* Assign unique id used for navigation */
  task.id = 'hhx-' + (index + 1 < 10 ? '0' : '') + (index + 1);

  /* Check taskId is set when required and unique */
  if (task.taskId) {
    if (taskIdsArr.indexOf(task.taskId) >= 0) {
      console.error('Task id not unique: ', task.taskId);
    } else {
      taskIdsArr.push(task.taskId);
    }
  } else {
    console.error('Missing task id for task: ', task);
  }
});

export {
  tasksData
};